// extracted by mini-css-extract-plugin
export var root = "LIBX";
export var rootBody = "uYd7";
export var rootDescription = "_6GBC";
export var rootHeading = "W3p9";
export var rootIcon = "pHoT";
export var rootIconCover = "LTBy";
export var rootIconCoverWrapper = "B+34";
export var rootIconWrapper = "_8hWm";
export var rootPercent = "_4PIa";